import {Box, Button, Grid, FormControl, Select} from "@material-ui/core";
import {OutTable, ExcelRenderer} from "react-excel-renderer";
import React, {useState} from "react";
import {notification} from "../functions/notification";
import InputLabel from "@material-ui/core/InputLabel";
import {useContext} from "react";
import {ListContext} from "../context/ListContext";
import {InputContext} from "../context/InputContext";
import {ConfirmationContext} from "../context/ConfirmationContext";
import {AuthContext} from "../context/AuthContext";
import UploadFile from "../components/UploadFile";
import {convertUndefined} from "../functions/convertUndefined";
import {populateAtlasNames} from "./populateAtlasNames";

const INITIAL_VALUES = {
	name: "",
	email: "",
	phone: "",
	remark: "",
};

const NAMES = ["name", "email", "phone", "remark"];

export default function UploadExcel({handleClose}) {
	const [rows, setRows] = useState();
	const [columns, setColumns] = useState();
	const [state, setState] = useState(INITIAL_VALUES);
	const [names, setNames] = useState(NAMES);
	const {openConfirmation} = useContext(ConfirmationContext);

	const handleClickUpload = (files) => {
		console.log(files);
		fileHandler(files);
	};

	const fileHandler = (files) => {
		let fileObj = files[0];

		//just pass the fileObj as parameter
		ExcelRenderer(fileObj, (err, resp) => {
			if (err) {
				console.log(err);
			} else {
				setRows(resp.rows);
				setColumns(resp.cols);
			}
		});
	};

	const handleSeed = async () => {
		if (!rows) {
			notification("Opps", "Please select a valid Excel file first", "warning");
			return;
		}

		const leads = [];
		for (let i = 1; i < rows.length; i++) {
			let lead = {
				name: rows[i][parseInt(state["name"])],
				email: rows[i][parseInt(state["email"])],
				phone: rows[i][parseInt(state["phone"])],
				remark: rows[i][parseInt(state["remark"])],
			};
			lead = convertUndefined(lead);
			leads.push(lead);
		}
		console.log(leads);
		const message = (
			<div>
				<div>Name: {leads[0].name}</div>
				<div>Phone: {leads[0].phone}</div>
				<div>Email: {leads[0].email}</div>
				<div>Remark: {leads[0].remark}</div>
			</div>
		);
		const response = await openConfirmation("Confirm upload", message);
		if (response) {
			await populateAtlasNames(leads);
		}
	};

	const handleChange = (e) => {
		const {value, name} = e.target;
		setState({...state, [name]: value});
	};

	return (
		<Box m={1}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<UploadFile handleClickUpload={handleClickUpload} />
					<Box mt={1}>
						<Button size="large" variant="contained" color="secondary" onClick={handleSeed}>
							Upload
						</Button>
					</Box>
				</Grid>

				<Grid item xs={12}>
					{names &&
						names.map((key, i) => (
							<Grid item xs={11} md={7} key={i}>
								<FormControl variant="outlined" fullWidth style={{margin: "10px"}}>
									<InputLabel>{key}</InputLabel>
									<Select
										native
										value={state[key]}
										onChange={handleChange}
										inputProps={{
											name: key,
										}}
									>
										{rows &&
											rows[0].map((header, i) => (
												<React.Fragment key={i}>
													{i === 0 && <option value={""} />}
													<option value={i}>{header}</option>
												</React.Fragment>
											))}
									</Select>
								</FormControl>
							</Grid>
						))}
				</Grid>

				<Grid item xs={12}>
					<OutTable
						data={rows ? rows : []}
						columns={columns ? columns : []}
						tableClassName="ExcelTable2007"
						tableHeaderRowClass="heading"
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
